import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, getDocs, } from "firebase/firestore";
import { Link } from 'react-router-dom';
import { db } from '../../firebase'
import Navbar from '../inc/Header';
import ScrollToTop from "react-scroll-to-top";




function CompleteEvent() {
    const [setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [showPerPage, setShowPerPage] = useState(450);
    const [pagination, setPagination] = useState({
        start: 0,
        end: showPerPage,
    });

    const onPaginationChange = (start, end) => {
        setPagination({ start: start, end: end });
    };
    const [searchTerm, setsearchTerm] = useState("");
    const [member, setMember] = useState([])
    const navigate = useNavigate()

    const memberCollectionRef = collection(db, "COMPLETE EVENT");
    useEffect(() => {

        const getMember = async () => {
            const data = await getDocs(memberCollectionRef);
            setMember(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
        }

        getMember()
    }, [])
    return (

        <>
            <Navbar />


            <br />
            <br />
            <br />
            <br />
            <br />
            <br />

            <ScrollToTop smooth top="100" color="grey" />

            <br />

            <center>
                <div className='SCHOOLBERHAMPORE'>
                    <h1 className='mt-2' style={{ color: "darkBlue" }}><b>Completed Events Bulletin</b></h1>
                </div>
            </center>
            <br />
            <div className="album py-1">

                <div className="container">

                    <div className="row">

                        <div className="col-md-6">

                            <div className="card-body">
                                <input type="text" className="form-control" placeholder="Search.. " name="location"
                                    onChange={(e) => {
                                        setsearchTerm(e.target.value);
                                    }}
                                />
                                <div className="d-flex justify-content-between align-items-center">




                                </div>


                            </div>


                        </div>

                    </div>

                </div>
            </div>
            <div className="album py-4">

                <div className="container">

                    <div className="row">
                        {member.filter((val) => {
                            if (setsearchTerm === "") {
                                return val;
                            } else if (
                                val.title.toLowerCase().includes(searchTerm.toLowerCase())




                            ) {
                                return val;
                            }
                        }).slice(pagination.start, pagination.end).map((misaa) => {
                            return (

                                <div className="col-md-3">
                                    <div className="card ">
                                 
                                        <div class="card-body">

                                            <h6 style={{color:"darkBlue"}} className="card-text "> <b>{misaa.title}</b></h6>
                                        </div>

                                    </div>



                                </div>
                            )
                        })}
                    </div>

                </div>
            </div>

        </>

    );
}

export default CompleteEvent;